<template>
  <div class="cmp-distribution-statement-statement_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="$t('search')"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          :options="channelTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 200px"
          :placeholder="'Channel'"
          deselect
          borderbottom
          :selected="
            channelTV.find((e) => e.value == basicFilter.digital_physical)
          "
          :listHeight="260"
          v-on:selectedChange="(e) => onDropdownChange('digital_physical', e)"
        />

        <Dropdown
          :options="statusTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 200px"
          :placeholder="'Status'"
          deselect
          borderbottom
          :selected="
            statusTV.find((e) => e.value == basicFilter.invoice_filter)
          "
          v-on:selectedChange="(e) => onDropdownChange('invoice_filter', e)"
        />

        <Dropdown
          :options="yearsTV"
          style="margin-top: -1px; margin-left: 20px; min-width: 200px"
          :placeholder="'Year'"
          deselect
          borderbottom
          :selected="yearsTV.find((e) => e.value == basicFilter.statement_year)"
          v-on:selectedChange="(e) => onDropdownChange('statement_year', e)"
        />

        <Dropdown
          style="margin-top: -1px; margin-left: 20px; min-width: 200px"
          :placeholder="$dft.capHead($t('Period'))"
          :options="periodTV"
          deselect
          borderbottom
          :selected="
            periodTV.find((e) => e.value == basicFilter.statement_period_txt)
          "
          v-on:selectedChange="
            (e) => onDropdownChange('statement_period_txt', e)
          "
        />
      </div>
      <!-- <div class="search-config--container">
          <div class="search-config">
            <SearchConBadge
              v-for="sconKey of filteredAdvancedSearchConfigKeys"
              :key="sconKey"
              v-bind="searchConfigKey(sconKey)"
              @delete="onSearchConDelete"
            />
          </div>
      </div> -->
      <!-- <div class="right-container ut-colcen">
        <div class="ut-flex">

          <button
            class="dt-button v5 s8"
            @click="onRefresh"
          >
            {{ $t("Refresh") }}
          </button>
        </div>
      </div> -->
    </div>

    <div class="dt-page--body" :style="{ '--offset': '120px' }">
      <NTable
        id="distribution-statement-statement_list"
        class="h1"
        :config="tableConfig"
        :headers="contactHeaders"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onDistributionStatementNext"
      >
        <!-- @click="onClickStatement(item)" -->
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onDistributionStatementClicked(item)"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td v-bind="tdcon('statements')">
              <span style="font-weight: bold">{{ item["account_name"] }}</span>
            </td>

            <td v-bind="tdcon('description')">
              <span>{{ item["description"] }}</span>
            </td>
            <td v-bind="tdcon('channel')">
              <span>{{ item["digital_physical"] }}</span>
            </td>
            <td v-bind="tdcon('period')">
              <span>{{ item["statement_period_txt"] }}</span>
            </td>
            <td v-bind="tdcon('year')">
              <span>{{ item["statement_year"] }}</span>
            </td>
            <td v-bind="tdcon('amount')">
              <span
                >{{ item["statement_amount"] || `0.00` }}
                {{ item["currency_iso"] }}</span
              >
            </td>
            <td v-bind="tdcon('invoice')">
              <span
                class="ut-link ut-text-accent5"
                @click.stop="onInvoiceClick(item)"
                >{{ item["invoice_ref"] }}</span
              >
            </td>
            <td v-bind="tdcon('options')">
              <img
                v-if="!item['invoice_id']"
                @click.stop="(e) => deleteStatement(item)"
                src="static/icons/delete.svg"
                class="dt-icon v5 s2 ut-center"
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>

    <Sidewindow
      :value="distributionStatementDetailsFlag"
      @closed="onCloseDistributionStatementDetails"
    >
      <StatementSidewindow
        :distributionStatementDetails="distributionStatementDetails"
      />
    </Sidewindow>

    <!-- <ModalContainer :modalKey="'advanceSearch'" :width="'420'">
        <AdvanceSearch  v-if="releasesCatalogData"
           :initSearchFilter="searchFilter"
           :advancedSearchData="advancedSearchData" 
           @search="onAdvancedSearch"
           @create_group="onAdvancedSearchCreateGroup"
           @cancelled="onAdvancedSearchCancelled"  
           
        />
    </ModalContainer> -->

    <!-- <ModalContainer  @cancelled="onCancel" :modalKey="'batchStatement'" :width="'400'">
      <BatchStatement  @cancelled="onCancel" />
    </ModalContainer> -->
    <!-- <ModalContainer
      @cancelled="onCancel"
      :modalKey="'addAccount'"
      :width="'400'"
    >
      <AddAccountModal
        @addLicenceAccount="addLicenceAccount"
        @cancelled="onCancel"
      />
    </ModalContainer> -->

    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'manualMatchModal'"
      :width="'1200'"
    >
      <ManualMatchModal @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'calculatePpuModal'"
      :width="'small'"
    >
      <CalculatePPUModal @calculatePPU="onCalculatePPU" @cancelled="onCancel" />
    </ModalContainer>
    <ModalContainer
      @cancelled="onCancel"
      :modalKey="'addNewPreset'"
      :width="'small'"
    >
      <AddNewPresetModal @create="onCreatePreset" @cancelled="onCancel" />
    </ModalContainer>
  </div>
</template>

<script>
// import Modal from '../../../../dt-plugins/modal/modal';
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
//import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

// import InputField from "@plugins/text-field/input-field";

import { ConfirmationService } from "@/dt-plugins/confirmation/confirmation.service";
import { createNTableConfig } from "../../../../plugins/datatable";

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
// import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";

import Sidewindow from "@/dt-plugins/sidewindow/sidewindow";

import { createTV, tv } from "../../../../models/text-value.model";

import { mapGetterObject, mapActionObject } from "../../../../store/global";

import {
  getDistributionStatementDetailsSelectable,
  distributionStatementListLDTRoutes,
} from "../../router/routes";
import {
  onDetailsRowClicked,
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";

import { sendMail, sendMailHref } from "../../../../utility";
import { distributionStatementsGetters } from "../../store/statement/getters";
import { distributionStatementsActions } from "../../store/statement/actions";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";

import ManualMatchModal from "./manual-match-modal.vue";
import CalculatePPUModal from "./calculate-ppu-modal.vue";
import AddNewPresetModal from "./add-new-preset-modal.vue";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";
import StatementSidewindow from "./statement-sidewindow";
import { DistributionStatementService } from "../../services/statement.service";
const LDTConfig = {
  entityName: "statement",
  ldtRoutes: distributionStatementListLDTRoutes,
  detailsSelectableFunction: getDistributionStatementDetailsSelectable,
  primaryKey: "statement_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.DistributionStatementsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.DistributionStatementsDetails.FETCH.SINGLE,
};

export default {
  components: {
    NTable,
    ModalContainer,
    StatementSidewindow,
    ManualMatchModal,
    CalculatePPUModal,
    AddNewPresetModal,
    Sidewindow,
  },
  mounted: function () {},
  data: function () {
    return {
      selectedClickedLicenceAccount: null,
      selectedStatement: null,
    };
  },
  mixins: [
    createLDTHost(LDTConfig),

    createFetchListMixin(ActionTypes.DistributionStatementsList.FETCH.ALL),
    createModalMixin("addNewPreset"),
    createModalMixin("addAccount"),
    createModalMixin("createInvoiceProjects"),
    createModalMixin("manualMatchModal"),
    createModalMixin("calculatePpuModal"),

    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
  ],
  watch: {
    $route: {
      immediate: true,
      handler: function (to, from) {},
    },
  },
  computed: {
    ...mapGetterObject(storeNS, distributionStatementsGetters),
    periodTV: function () {
      return [
        { text: "M1", value: "M1" },
        { text: "M2", value: "M2" },
        { text: "M3", value: "M3" },
        { text: "M4", value: "M4" },
        { text: "M5", value: "M5" },
        { text: "M6", value: "M6" },
        { text: "M7", value: "M7" },
        { text: "M8", value: "M8" },
        { text: "M9", value: "M9" },
        { text: "M10", value: "M10" },
        { text: "M11", value: "M11" },
        { text: "M12", value: "M12" },
        { text: "Q1", value: "Q1" },
        { text: "Q2", value: "Q2" },
        { text: "Q3", value: "Q3" },
        { text: "Q4", value: "Q4" },
        { text: "S1", value: "S1" },
        { text: "S2", value: "S2" },
        { text: "Y", value: "Y" },
      ];
    },
    
    yearsTV:function(){
      console.log("this.distributionStatementList",this.distributionStatementList)
      if(!this.distributionStatementList){
          return [];
      } 
      const minYear=parseInt(this.distributionStatementList?.min_max_year?.min_year)
      const maxYear=parseInt(this.distributionStatementList?.min_max_year?.max_year)
      const yearLength=parseInt(maxYear+1 - minYear)
      console.log("yearLength",minYear,maxYear,yearLength)
      const tvArray = [...Array(yearLength).keys()].map(
        (_,i) => { 
                 
                  return { text:minYear+i,value:minYear+i } 
               }
      );
      return tvArray.sort().reverse()||[];
    },
    channelTV: function () {
      return [
        { text: "Digital", value: "digital" },
        { text: "Physical", value: "physical" },
        { text: "Costs", value: "costs" },
        { text: "Third Party", value: "thirdparty" },
        { text: "Performance", value: "performance" },
        { text: "Other Income", value: "income" },
        //{ text:'Multi',value:'multi' },
      ];
    },
    statusTV: function () {
      return [
        { text: "Open", value: "not_invoiced" },
        { text: "History", value: "invoiced" },
      ];
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },

    distributionStatementDetailsFlag: function () {
      return childOfOrEqualDetails(
        distributionStatementListLDTRoutes,
        this.$route
      );
    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      });
    },
    list: function () {
      return this.distributionStatementList?.statements || [];
    },

    contactHeaders: function () {
      return [
        createTableHeader("statements", { fw: 700 }),
        // createTableHeader("keyword", { }),
        createTableHeader("description", {}),
        createTableHeader("channel", {}),
        createTableHeader("period", {}),
        createTableHeader("year", {}),
        createTableHeader("amount", { ta: "right" }),
        createTableHeader("invoice", {}),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    advancedSearchData: function () {
      return {};
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionStatementsActions),
    fetchAdvancedSearchData: function () {},
    defaultBasicFilter() {
      //<-- Needed for BasicSearch. Provide the basic Filter Object. Supports String/Boolean/Number
      return {
        searchString: undefined,
        digital_physical: undefined,
        invoice_filter: undefined,
        statement_year: undefined,
        statement_period_txt: undefined,
      };
    },
    onAddAccountClicked: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_account",
        },
      });
    },

    addLicenceAccount: function (payload) {
      this[ActionTypes.LicenceAccountsList.INSERT.SINGLE](payload);
      this.onCancel();
    },
    onDropDownUpdate: function (name, value, item) {
      const payload = {
        kVal: item.licence_account_id,
        name: name,
        value: value.value,
      };
      this[ActionTypes.LicenceAccountsList.UPDATE.SINGLE](payload);
    },
    onDropdownChange: function (name, value) {
      // <-- Normal Form Handling Methods
      this.basicFilter[name] = value.value;

      this.fetchListReset();
    },
    onTextFieldChange: function (event, item) {
      console.log(event, item);
      const payload = {
        kVal: item.licence_account_id,
        name: event.name,
        value: event.value,
      };
      this[ActionTypes.LicenceAccountsList.UPDATE.SINGLE](payload);
    },
    deleteStatement: async function (item) {
      const confirmationResult = await confirmDelete(
        "Statement",
        item.account_name
      );
      if (confirmationResult == "OK") {
        this[ActionTypes.DistributionStatementsList.DELETE.SINGLE](item);
      }
      // ConfirmationService.create({
      //   subject: this.$t("delete_dist_statement_msg"),
      //   model: true,
      //   width: 500,
      //   completed: res => {
      //     switch (res) {
      //       case "OK": {
      //         this[ActionTypes.DistributionStatementsList.DELETE.SINGLE](item);
      //         // console.log(item);
      //         break;
      //       }
      //       default: {
      //       }
      //     }
      //   }
      // });
    },
    selectedRow: function (item) {
      return (
        this.selectedClickedLicenceAccount &&
        this.selectedClickedLicenceAccount["licence_account_id"] ==
          item["licence_account_id"]
      );
    },

    emailLink: function (item) {
      const body = "";

      const subject = "Licence Reminder " + item.licence_account_name;

      const mails = [item.email1];

      console.log("subject,body,recepient", item);

      sendMailHref({ subject, body, mails });
      //sendMail({ subject, body, mails });
    },
    onDistributionStatementClicked: async function (item) {
      if (this.loadingFlag) {
        return;
      }

      console.log(":::::::::", item);

      const { statement_id } = item;

      let tab = "import";

      if (item.invoice_id && item.invoice_id != null) {
        tab = "import_result";
      } else {
        const res = await DistributionStatementService.statementImportErrorData(
          statement_id
        );
        const lines = res.data.statement_lines;
        tab = lines.length > 0 ? "import_matching" : "import_result";

        console.log(tab, "tab", "lines:::::::", lines);
        // if(lines.length>0){
        //   tab = 'import_matching'
        // }else{
        //   console.log("::::::::::lines:::::::",lines)
        //   tab = 'import_result'
        // }
      }

      //this.selectedClickedLicenceAccount = item;
      this.$router.push({
        name: distributionStatementListLDTRoutes.names.tab,
        params: {
          statement_id: statement_id,
          tab: tab,
        },
      });
    },
    onCloseDistributionStatementDetails: function () {
      this.selectedClickedLicenceAccount = null;
      this.fetchListReset();
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionStatementListLDTRoutes.names.list,
        });
      });
    },

    onDistributionStatementNext: function (value) {
      this.scrollSubject.next(value);
    },

    onInvoiceClick: function (item) {
      console.log(item);
      this.$router.push({
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id: item.invoice_id,
          tab: "overview",
        },
      });
    },
    onCancel: function () {
      closeModalRoute(this);
    },

    onCalculatePPU: function (payload) {
      this[ActionTypes.DistributionStatementImportResultDigital.UPDATE.ALL](
        payload
      );
      this.onCancel();
    },

    onCreatePreset: async function (payload) {
      console.log(payload, ":::::::");

      const { preset_name, digital_physical } = payload;

      await DistributionStatementService.channelPresetName(
        digital_physical,
        preset_name
      );

      await DistributionStatementService.newPreset({ ...payload });
      this.onCancel();
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-statement-statement_list {
  .dt-page--body {
    --offset: 190px;
  }
  td.file_name a {
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .input-field-container {
      max-width: 128px;
    }
  }
  // .invoicelist-footer {
  //   border-top: 1px solid var(--sprt-5);

  //   .invoice_status_list {
  //     display: flex;
  //     .status {
  //       margin-top: 15px;
  //       display: flex;
  //       // max-width: 150px;
  //       flex: 0.5;
  //       .circle {
  //         width: 15px;
  //         height: 15px;

  //         margin-right: 10px;
  //         margin-top: 2.5px;
  //       }
  //       .status-name {
  //         flex: 1;
  //       }
  //     }
  //   }
  // }
}
</style>
